module.exports = __webpack_public_path__ + "static/img/zyzq-bg.7910278.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zyzq-bg.png
// module id = u2zD
// module chunks = 3